const isSparePart = window.location.pathname.indexOf('/p-a/') > -1;

const fwk = window.cube.config.anly_useLegacy === 'Y' ? CUBE.Analytics : {};
const tc_vars = window.tc_vars || {};

let tracker;
let event;
let clickPostAction;

const bindFunctionToEvents = (func, events) => {
  // eslint-disable-next-line no-restricted-syntax
  for (const evt in events)
    if (events[evt].trigger && events[evt].trigger === 'click')
      events[evt].postAction(func);
};

/* ENHANCED E-COMMERCE - CLICK */
export const initCatalog = () => {
  if (
    !['list', 'internal_search', 'product', 'suggestions'].includes(
      tc_vars.env_template
    ) && window.cube.config.anly_useLegacy !== 'Y'
  )
    return;

  // PAGE LIST
  if (['list', 'internal_search'].includes(tc_vars.env_template)) {
    // PAGELIST PRODUCTS
    tracker =
      CUBE.Analytics.trackers.list[
        AnalyticsConstants.trackers.product.productList.name
      ];
    if (!tracker) return;
    clickPostAction = $element => {
      // Get the selected model
      let model;
      if (isSparePart) model = fwk.utils.pagelist.parseSparePart($element);
      else model = fwk.utils.pagelist.parseProduct($element);
      fwk.enhanced.setModelVada(model); // set 'model.category' with 'model.vada{}' info (if any)
      // Save the position in the ENHANCED storage
      fwk.enhanced.set({
        id: model.id,
        position: model.position,
        list: model.list,
        variant: model.variant,
        category: model.category,
        label: model.name,
        brand: model.brand,
      });
      fwk.enhanced.sendClick(model);
    };
    bindFunctionToEvents(clickPostAction, tracker.events);
  }
  // PRODUCT PAGE
  if (tc_vars.env_template === 'product') {
    // PAGELIST PRODUCTS
    tracker =
      CUBE.Analytics.trackers.list[
        AnalyticsConstants.trackers.product.lvp.name
      ];
    if (!tracker) return;
    clickPostAction = function($element) {
      const isLVP = $element.hasClass('plv2-element');
      // Get the selected model
      let model;
      if (isSparePart) model = fwk.utils.pagelist.parseSparePart($element);
      else if (isLVP) model = fwk.utils.pagelist.parseLVP($element);
      else model = fwk.utils.pagelist.parseProduct($element);
      fwk.enhanced.setModelVada(model); // set 'model.category' with 'model.vada{}' info (if any)
      // Save the position in the ENHANCED storage
      fwk.enhanced.set({
        id: model.id,
        position: model.position,
        list: model.list,
        variant: model.variant,
        category: model.category,
        label: model.name,
        brand: model.brand,
      });
      fwk.enhanced.sendClick(model);
    };
    bindFunctionToEvents(clickPostAction, tracker.events);
  }
};

export const initCheckout = () => {
  if (!['checkout'].includes(tc_vars.env_template)
    && window.cube.config.anly_useLegacy !== 'Y') return;
  // BASKET PAGE

  // SAVELATER PRODUCT
  event = CUBE.Analytics.utils.getEvent('savelaterGoBackToProduct');
  if (!event) return;
  clickPostAction = function($element) {
    const model = this.model; // postAction autobind event as 'this' value
    fwk.enhanced.setModelVada(model); // set 'model.category' with 'model.vada{}' info (if any)
    fwk.enhanced.set({
      id: model.id,
      position: model.position,
      list: '/checkout/cart',
      variant: model.variant,
      category: model.category,
      label: model.name,
      brand: model.brand,
    });
    fwk.enhanced.sendClick(model);
  };
  bindFunctionToEvents(clickPostAction, [event]);
};



// WEBPACK FOOTER //
// ./src/analytics/enhanced/ec-2-click.js